import { api } from '@/api';

export interface PostMessageFeedbackRequest {
  messageId: string;
  isPositive: boolean;
  reason?: string;
  comment?: string;
}

const chatMessageFeedbackApi = api.injectEndpoints({
  endpoints: (builder) => ({
    postMessageFeedback: builder.mutation<void, PostMessageFeedbackRequest>({
      query: ({ messageId, isPositive, reason, comment }) => ({
        url: '/chat/message/feedback',
        method: 'POST',
        body: {
          messageId,
          isPositive,
          reason,
          comment,
        },
      }),
      extraOptions: { maxRetries: 0 },
    }),
  }),
});

export const { usePostMessageFeedbackMutation } = chatMessageFeedbackApi;
